// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const GridView: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14">
            <path
                fill="currentColor"
                d="M14 0H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm.5 2v4.25H8.75V1.5H14c.275 0 .5.224.5.5ZM2 1.5h5.25v4.75H1.5V2a.5.5 0 0 1 .5-.5ZM1.5 12V7.75h5.75v4.75H2a.501.501 0 0 1-.5-.5Zm12.5.5H8.75V7.75h5.75V12c0 .275-.225.5-.5.5Z"
            />
        </svg>
    );
};

export default React.memo(GridView);
